import React from 'react'
import '../css/healthnews.css'
import Navbar from '../Navbar'

export default function HealthCare1() {
  return (
    <>
    <Navbar/>
    
    <div className="container" id='white' >
  {/* Main Article */}
  <article className="main-article" id='orange'>
    <div className="grid-layout">
      {/* Main Content */}
      <div className="main-content">
        {/* Featured Article */}
        <div className="featured-articl">
          <a href="#">
          <img
            src="./images/irans-suprem.jpg"
            alt="Business people in a hallway"
            className="featured-image"
          />
          </a>
          <a href="#" className='anchor'>
          <h1>
          Iran’s Supreme Leader Threatens Israel and U.S. With ‘a Crushing Response’ Over Israeli Attack
          </h1>
          </a>
          
          <div className="author-info">
            
            <span>By Kelly Phillips Erb</span>
            <span className="separator">|</span>
            <span>EI Staff</span>
          </div>
          <div className="news-showcase">
            <p> DUBAI, United Arab Emirates — Iran’s supreme leader on Saturday threatened Israel and the U.S. with “a crushing response” over attacks on Iran and its allies.

Ayatollah Ali Khamenei spoke as Iranian officials are increasingly threatening to launch yet another strike against Israel after its Oct. 26 attack on the Islamic Republic that targeted military bases and other locations and killed at least five people.

Any further attacks from either side could engulf the wider Middle East, already teetering over the Israel-Hamas war in the Gaza Strip and Israel’s ground invasion of Lebanon, into a wider regional conflict just ahead of the U.S. presidential election this Tuesday.

“The enemies, whether the Zionist regime or the United States of America, will definitely receive a crushing response to what they are doing to Iran and the Iranian nation and to the resistance front,” Khamenei said in video released by Iranian state media.

The supreme leader did not elaborate on the timing of the threatened attack, nor the scope. The U.S. military operates on bases throughout the Middle East, with some troops now manning a Terminal High Altitude Area Defense, or THAAD, battery in Israel.

The USS Abraham Lincoln aircraft carrier likely is in the Arabian Sea, while Pentagon press secretary Maj. Gen. Pat Ryder said Friday that more destroyers, fighter squadrons, tankers and B-52 long-range bombers would be coming to the region to deter Iran and its militant allies.

The 85-year-old Khamenei had struck a more cautious approach in earlier remarks, saying officials would weigh Iran’s response and that Israel’s attack “should not be exaggerated nor downplayed.” Iran has launched two major direct attacks on Israel, in April and October.

But efforts by Iran to downplay the Israeli attack faltered as satellite photos analyzed by The Associated Press showed damage to military bases near Tehran linked to the country’s ballistic missile program, as well as at a Revolutionary Guard base used in satellite launches.

Iran’s allies, called the “Axis of Resistance” by Tehran, also have been severely hurt by ongoing Israeli attacks, particularly Lebanon’s Hezbollah and Hamas in the Gaza Strip. Iran long has used those groups as both an asymmetrical way to attack Israel and as a shield against a direct assault. Some analysts believe those groups want Iran to do more to back them militarily.

Iran, however, has been dealing with its own problems at home, as its economy struggles under the weight of international sanctions and it has faced years of widespread, multiple protests. After Khamenei’s speech, the Iranian rial fell to 691,500 against the dollar, near an all-time low. It had been 32,000 rials to the dollar when Tehran reached its 2015 nuclear deal with world powers.

Gen. Mohammad Ali Naini, a spokesman for Iran’s paramilitary Revolutionary Guard which controls the ballistic missiles needed to target Israel, gave an interview published by the semiofficial Fars news agency just before Khamenei’s remarks were released. In it, he warned Iran’s response “will be wise, powerful and beyond the enemy’s comprehension.”

“The leaders of the Zionist regime should look out from the windows of their bedrooms and protect their criminal pilots within their small territory,” he warned. Israeli air force pilots appear to have used air-launched ballistic missiles in the Oct. 26 attack.

Khamenei on Saturday met with university students to mark Students Day, which commemorates a Nov. 4, 1978, incident in which Iranian soldiers opened fire on students protesting the rule of the shah at Tehran University. The shooting killed and wounded several students and further escalated the tensions consuming Iran at the time that eventually led to the shah fleeing the country and the 1979 Islamic Revolution.

The crowd offered a raucous welcome to Khamenei, chanting: “The blood in our veins is a gift to our leader!” Some also made a hand gesture — similar to a “timeout” signal — given by the slain Hezbollah leader Hassan Nasrallah in 2020 in a speech in which he threatened that American troops who arrived in the Mideast standing up would “return in coffins” horizontally.

Iran will mark the 45th anniversary of the U.S. Embassy hostage crisis this Sunday, following the Persian calendar. The Nov. 4, 1979, storming of the embassy by Islamist students led to the 444-day crisis, which cemented the decades-long enmity between Tehran and Washington that persists today.</p>
          </div>
          
        </div>
        {/* Secondary Articles Grid */}
        <div className="secondary-articles">
          {/* Article 1 */}
          <div className="articl">
            <a href="#">
            <img
              src="./images/trump.png"
              alt="Capitol building"
            />
            </a>
            <a href="#" className='anchor'>
            <h2>
              With A Government Shutdown Deadline Looming, IRS Funding Hangs In
              The Balance
            </h2>
            </a>
            <div className="author-info">
              By Kelly Phillips Erb | TSD Staff
            </div>
            
          </div>
          {/* Article 2 */}
          <div className="articl">
            <a href="#">
            <img
              src="./images/trump.png"
              alt="Stock market data"
            />
            </a>
            <a href="#" className='anchor'>
            <h2>
              America's Top 100 Mid-Cap Stocks: Meet The Companies Powering The
              AI Boom
            </h2>
            </a>
            
            
            <div className="author-info">By Hank Tucker | TSD Staff</div>
            
          </div>
        </div>
      </div>
      {/* Sidebar */}
      <aside className="sidebar">
        {/* Sidebar Article 1 */}
        <div className="sidebar-article">
          <a href="#">
          <img
            src="./images/trump.png"
            alt="Tax document review"
          />
          </a>
          <a href="#" className='anchor'>
          <h2>We Need A Big, Fat Tax Cut Fast</h2>
          </a>
          <div className="author-info">By Steve Forbes | TSD Staff</div>
        </div>
        {/* Sidebar Article 2 */}
        <div className="sidebar-articl">
          <a href="#">
          <img
            src="./images/trump.png"
            alt="Small business owner"
          />
          </a>
          <a href="#" className='anchor'>
          <h2>
            How A New SBA Lending Rule Gives Buyers The Chance To Cut Deals Like
            Private Equity Pros
          </h2>
          </a>
          
          <div className="author-info">By Brandon Kochkodin | TSD Staff</div>
        </div>
        <div className="sidebar-articl">
          <a href="#">
          <img
            src="./images/trump.png"
            alt="Small business owner"
          />
          </a>
          <a href="#" className='anchor'>
          <h2>
            How A New SBA Lending Rule Gives Buyers The Chance To Cut Deals Like
            Private Equity Pros
          </h2>
          </a>
          
          <div className="author-info">By Brandon Kochkodin | TSD Staff</div>
        </div>
        <div className="sidebar-articl">
          <a href="#">
          <img
            src="./images/trump.png"
            alt="Small business owner"
          />
          </a>
          <a href="#" className='anchor'>
          <h2>
            How A New SBA Lending Rule Gives Buyers The Chance To Cut Deals Like
            Private Equity Pros
          </h2>
          </a>
          
          <div className="author-info">By Brandon Kochkodin | TSD Staff</div>
        </div>
      </aside>
    </div>
  </article>
  
</div>

</>



  )
}
